import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../../../environments/environments";
import { Observable, of } from "rxjs";
import { CustomerProfile } from "./interfaces/customer-profile.interface";
import { CustomerByIdModel, IndicatorsCustomer, ProcedureCategory } from './interfaces/customer.interface';

export var CUSTOMERS: CustomerByIdModel[] = [
  {
    id: 1,
    name: "Banmedica - Clínica Dávila Recoleta",
    code: "",
    sectorName: "RM1",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "Clinica Davila Y Servicios Medicos S.A.",
    customerType: 1,
    documentNumber: "96.530.470-3",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "600 600 3600",
    email: "jorge.burgos@davila.cl",
    createdDate: new Date("2026-01-14T09:15:00"),
    updatedDate: new Date("2026-02-12T10:40:00"),
    addresses: [
      {
        zipCode: "8431657",
        street: "Av. Recoleta 464",
        number: "464",
        state: "",
        city: "Santiago",
        neighborhood: "Recoleta",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },

  {
    id: 2,
    name: "Banmedica - Clínica Dávila Vespucio",
    code: "",
    sectorName: "RM1",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "CLINICA VESPUCIO SPA",
    customerType: 1,
    documentNumber: "96898980-4",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "2270 2700",
    email: "dzuniga@davilavespucio.cl",
    createdDate: new Date("2026-01-08T14:20:00"),
    updatedDate: new Date("2026-03-01T16:45:00"),
    addresses: [
      {
        zipCode: "8240000",
        street: "Serafín Zamora 190",
        number: "190",
        state: "",
        city: "Santiago",
        neighborhood: "La Florida",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 12,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },

  {
    id: 3,
    name: "Banmedica - Clínica Santa Maria",
    code: "",
    sectorName: "RM1",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "CLINICA SANTA MARIA S.A",
    customerType: 1,
    documentNumber: "90753000-0",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "229130000",
    email: "heidy.salazar@clinicasantamaria.cl",
    createdDate: new Date("2026-02-05T08:10:00"),
    updatedDate: new Date("2026-03-06T11:30:00"),
    addresses: [
      {
        zipCode: "7520349",
        street: "Av. Santa Maria 0500",
        number: "500",
        state: "",
        city: "Santiago",
        neighborhood: "Providencia",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 8,
    unitId: 2,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },

  {
    id: 4,
    name: "CENTRO MEDICO QUALIA SPA",
    code: "",
    sectorName: "RM1",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "CENTRO MEDICO QUALIA SPA",
    customerType: 1,
    documentNumber: "77.881.583-4",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "",
    email: "-",
    createdDate: new Date("2026-01-19T13:00:00"),
    updatedDate: new Date("2026-02-28T10:50:00"),
    addresses: [
      {
        zipCode: "",
        street: "",
        number: "",
        state: "",
        city: "",
        neighborhood: "",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 15,
    unitId: 7,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },

  {
    id: 5,
    name: "Clínica Alemana",
    code: "",
    sectorName: "RM1",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "CLINICA ALEMANA DE SANTIAGO S A",
    customerType: 1,
    documentNumber: "96.770.100-9",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "22101111",
    email: "jzuritam@alemana.cl",
    createdDate: new Date("2026-01-03T09:45:00"),
    updatedDate: new Date("2026-02-18T17:30:00"),
    addresses: [
      {
        zipCode: "8441226",
        street: "Av. Manquehue Norte 1410",
        number: "1410",
        state: "",
        city: "Santiago",
        neighborhood: "Vitacura",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 6,
    unitId: 1,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },

  {
    id: 7,
    name: "Clínica Indisa",
    code: "",
    sectorName: "RM1",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "INSTITUTO DE DIAGNOSTICO S A",
    customerType: 1,
    documentNumber: "92051000-0",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "23625555",
    email: "pallende@indisa.cl",
    createdDate: new Date("2026-01-25T15:20:00"),
    updatedDate: new Date("2026-03-07T12:10:00"),
    addresses: [
      {
        zipCode: "",
        street: "Av. Santa Maria 1810",
        number: "1810",
        state: "",
        city: "Santiago",
        neighborhood: "Providencia",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 9,
    unitId: 6,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 8,
    name: "Clínica Juan Pablo II",
    code: "",
    sectorName: "RM1",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "CORTES Y AGUILERA S.A.",
    customerType: 1,
    documentNumber: "89.593.200-0",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "24835100",
    email: "",
    createdDate: new Date("2026-02-09T11:00:00"),
    updatedDate: new Date("2026-03-02T10:00:00"),
    addresses: [
      {
        zipCode: "",
        street: "Av. Santa Rosa 1448",
        number: "1448",
        state: "",
        city: "Santiago",
        neighborhood: "Santiago",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 14,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 9,
    name: "Clínica Santa Rosa",
    code: "",
    sectorName: "RM1",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "MARÍA REBECA EUGENIA GONZÁLEZ ARAYA",
    customerType: 1,
    documentNumber: "76.173.214-5",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "26594300",
    email: "farmacia@clinicasantarosa.cl",
    createdDate: new Date("2026-01-15T08:00:00"),
    updatedDate: new Date("2026-02-26T15:45:00"),
    addresses: [
      {
        zipCode: "",
        street: "Av. Santa Rosa 1503",
        number: "1503",
        state: "",
        city: "Santiago",
        neighborhood: "Santiago",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 5,
    unitId: 2,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 10,
    name: "Clínica Univ. de los Andes",
    code: "",
    sectorName: "RM1",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "UNIVERSIDAD DE LOS ANDES",
    customerType: 1,
    documentNumber: "71614000-8",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "226183194",
    email: "QFsCUA@uandes.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Av. La plaza 2501",
        number: "2501",
        state: "",
        city: "Santiago",
        neighborhood: "Las Condes",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 11,
    name: "Clínica WLK SA",
    code: "",
    sectorName: "RM1",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "CLINICA WLK S.A",
    customerType: 1,
    documentNumber: "76.028.808-k",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "",
    email: "jsanchez@wlk.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Av. Los leones 485",
        number: "485",
        state: "",
        city: "Santiago",
        neighborhood: "Providencia",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 12,
    name: "Corporación de Ayuda al Niño Quemado - COANIQUEM",
    code: "",
    sectorName: "RM1",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "CORPORACIÓN DE AYUDA AL NIÑO QUEMADO",
    customerType: 1,
    documentNumber: "70.715.400-4",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "",
    email: "hgonzalez@coaniquem.org",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Av. San Francisco 8586",
        number: "8586",
        state: "",
        city: "Santiago",
        neighborhood: "Pudahuel",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 13,
    name: "FUND DOCTOR  GANTZ MANN",
    code: "",
    sectorName: "RM1",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "FUND DOCTOR ALFREDO GANTZ MANN",
    customerType: 1,
    documentNumber: "70.532.500-6",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "223386415",
    email: "denisse.alvarado@gantz.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Av. El Lazo 4585",
        number: "4585",
        state: "",
        city: "Santiago",
        neighborhood: "Pudahuel",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 14,
    name: "Instituto Oncológico FALP",
    code: "",
    sectorName: "RM1",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "FUNDACION ARTURO LOPEZ PEREZ (FALP)",
    customerType: 1,
    documentNumber: "70377400-8",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "8002480000",
    email: "margott.nunez@falp.org",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Antonio varas 621",
        number: "621",
        state: "",
        city: "Santiago",
        neighborhood: "Providencia",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 15,
    name: "Fundación oftalmologica Los Andes",
    code: "",
    sectorName: "RM1",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "FUNDACION OFTALMOLOGICA LOS ANDES",
    customerType: 1,
    documentNumber: "71457900-2",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "223704600",
    email: "farmacia@fola.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Las hualtatas 5951",
        number: "5951",
        state: "",
        city: "Santiago",
        neighborhood: "Vitacura",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 16,
    name: "INSTITUTO DE SEGURIDAD DEL TRABAJO",
    code: "",
    sectorName: "RM1",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "IST Instituto de Seguridad y Salud del Trabajo",
    customerType: 1,
    documentNumber: "70.015.580-3",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "224104477",
    email: "camila.aguirre@ist.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Av. Santa Maria 5950",
        number: "5950",
        state: "",
        city: "Santiago",
        neighborhood: "Vitacura",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 17,
    name: "Interclinica - Clínica Nueva Cordillera",
    code: "",
    sectorName: "RM1",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "Nueva Clínica Cordillera Prestaciones Hospitalizadas S.",
    customerType: 1,
    documentNumber: "76.871.990-K",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "",
    email: "kahumada@interclinica.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Av. Alejandro Fleming 7889",
        number: "7889",
        state: "",
        city: "Santiago",
        neighborhood: "Las Condes",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 18,
    name: "Mutual",
    code: "",
    sectorName: "RM1",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "MUTUAL DE SEGUROS DE CHILE",
    customerType: 1,
    documentNumber: "70.285.100-9",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "",
    email: "jjourdain@mutual.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Av. Alameda Libertador Bernardo O",
        number: "4848",
        state: "",
        city: "Santiago",
        neighborhood: "Estacion Central",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 19,
    name: "CLINICA MAITENES",
    code: "",
    sectorName: "RM1",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "SOC CLINICA MAITENES SPA",
    customerType: 1,
    documentNumber: "77.878.170-0",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "2 2870 5800",
    email: "eguzmand@clinicamaitenes.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Autopista del Sol, San Antonio Km.",
        number: "KM 70",
        state: "",
        city: "Santiago",
        neighborhood: "Melipilla",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 20,
    name: "Banmedica - Clínica Ciudad del Mar",
    code: "",
    sectorName: "CN",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "CLINICA CIUDAD DEL MAR S.A.",
    customerType: 1,
    documentNumber: "96885950-1",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "32 245 1000",
    email: "valeska.cisternas@ccdm.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "13 Norte 635",
        number: "635",
        state: "",
        city: "Valparaiso",
        neighborhood: "Viña del mar",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 21,
    name: "Clínica Reñaca",
    code: "",
    sectorName: "CN",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "Clinica Reñaca S A",
    customerType: 1,
    documentNumber: "79576810-6",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "600 712 0020",
    email: "Yeissy.Becerra@bupa.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Anabaena, Reñaca 336",
        number: "336",
        state: "",
        city: "Valparaiso",
        neighborhood: "Viña del mar",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 22,
    name: "HOSPITAL CLINICO VINA DEL MAR S A",
    code: "",
    sectorName: "CN",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "Hospital Clinico Viña del Mar S.A",
    customerType: 1,
    documentNumber: "96.963.660-3",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "(32) 232 3800",
    email: "abastecimiento@hospitalclinico.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "C. Limache 1741",
        number: "1741",
        state: "",
        city: "Valparaiso",
        neighborhood: "Viña del mar",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 23,
    name: "Clínica Miraflores",
    code: "",
    sectorName: "CN",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "Sociedad Administradora Clínica Miraflores S.A",
    customerType: 1,
    documentNumber: "76.491.710-3",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "(32) 238 9901",
    email: "adquisiciones@clinicamiraflores.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Los Fresnos 276",
        number: "276",
        state: "",
        city: "Valparaiso",
        neighborhood: "Viña del mar",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 24,
    name: "Interclinica - Clínica los Carreras",
    code: "",
    sectorName: "CN",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "CLÍNICA LOS CARRERA SERVISALUD S. A",
    customerType: 1,
    documentNumber: "96.600.850-4",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "",
    email: "mjimenez@interclinica.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Caupolicán",
        number: "958",
        state: "",
        city: "Valparaiso",
        neighborhood: "Quilpué",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 25,
    name: "Interclinica - Clínica los Leones",
    code: "",
    sectorName: "CN",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "SERVICLINICA S A",
    customerType: 1,
    documentNumber: "96.674.170-8",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "(33)2296410",
    email: "emartinez@interclinica.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "AV. La Torre 98",
        number: "98",
        state: "",
        city: "Valparaiso",
        neighborhood: "La Calera",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 26,
    name: "ACHS - Clínica Atacama",
    code: "",
    sectorName: "N",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "CLINICA ATACAMA SOCIEDAD POR ACCIONES",
    customerType: 1,
    documentNumber: "70.360.100-6",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "",
    email: "compradorinsumo@clinicaatacama.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Av. Jose Manuel Infante 861",
        number: "861",
        state: "",
        city: "Atacama",
        neighborhood: "Copiapó",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 27,
    name: "INTEGRAMEDICA S.A.",
    code: "",
    sectorName: "N",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "INTEGRAMEDICA S.A.",
    customerType: 1,
    documentNumber: "76.098.454-k",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "(2) 2636 6666",
    email: "Luis.Carrasco@integramedica.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Alberto Solari 1400",
        number: "1400",
        state: "",
        city: "Coquimbo",
        neighborhood: "La Serena",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 28,
    name: "Red Salud Elqui",
    code: "",
    sectorName: "N",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "EMPRESAS RED SALUD S.A",
    customerType: 1,
    documentNumber: "99.533.790-8",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "",
    email: "carolina.orellanab@redsalud.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Av. El Santo 1475",
        number: "1475",
        state: "",
        city: "Coquimbo",
        neighborhood: "La Serena",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 29,
    name: "ACHS - Clínica la Portada",
    code: "",
    sectorName: "N",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "Clínica Regional la Portada de Antofagasta S.A",
    customerType: 1,
    documentNumber: "99.537.800-0",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "",
    email: "nriquelme@clinicaportada.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Av. Balmaceda 2648",
        number: "2648",
        state: "",
        city: "Antofagasta",
        neighborhood: "Antofagasta",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 30,
    name: "Andes Salud El Loa",
    code: "",
    sectorName: "N",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "CLINICA ANDES SALUD EL LOA S.A",
    customerType: 1,
    documentNumber: "96.802.800-6",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "55 2424824",
    email: "patricio.montecino@andessalud.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Av. Granaderos 2924",
        number: "2924",
        state: "",
        city: "Antofagasta",
        neighborhood: "Calama",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 31,
    name: "CLINICA ANTOFAGASTA",
    code: "",
    sectorName: "N",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "SERVICIOS Y ABASTECIMIENTOS A CLINICAS S.A.",
    customerType: 1,
    documentNumber: "95431000-0",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "",
    email: "Javiera.Mancilla@Bupa.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Manuel Antonio Matta 1945",
        number: "1945",
        state: "",
        city: "Antofagasta",
        neighborhood: "Antofagasta",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 32,
    name: "Clínica Fleming",
    code: "",
    sectorName: "N",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "CENTRO DE ATENCIONES MEDICAS FLEMING ARICA S.A",
    customerType: 1,
    documentNumber: "76.349.565-5",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "(58) 223 6400",
    email: "0",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Av. Argentina 2247",
        number: "2247",
        state: "",
        city: "Arica",
        neighborhood: "Arica",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 33,
    name: "Interclinica - San José Interclínica",
    code: "",
    sectorName: "N",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "CORP MEDICA DE ARICA S A",
    customerType: 1,
    documentNumber: "96.613.220-5",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "(58) 223 2064",
    email: "klara@interclinica.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Avenida, Dr. Juan Noe 1370",
        number: "1370",
        state: "",
        city: "Arica",
        neighborhood: "Arica",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 13,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 34,
    name: "Interclínica - Serviclinica Iquique (Tarapacá)",
    code: "",
    sectorName: "N",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "",
    socialRason: "SERVICLINICA PRESTACIONES AMBULATORIAS S A",
    customerType: 1,
    documentNumber: "96.840.610-8",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "(57) 239 7000",
    email: "gmorandi@interclinica.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Barros Arana 1550",
        number: "103",
        state: "",
        city: "Iquique",
        neighborhood: "Iquique",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 14,
    unitId: 4,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 35,
    name: "UC Christus Servicios Clínicos",
    code: "995734907",
    sectorName: "RM",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "995734907",
    socialRason: "UC CHRISTUS SERVICIOS CLINICOS SPA",
    customerType: 1,
    documentNumber: "99.573.490-7",
    stateRegistration: "",
    isActive: true,
    phone: "56996469374",
    mainPhone: "",
    email: "avanega@ucchristus.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "MARCOLETA PISO -1, 350 SANTIAGO",
        number: "",
        state: "",
        city: "Santiago",
        neighborhood: "Santiago centro",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 36,
    name: "Clinica Meds",
    code: "763360393",
    sectorName: "RM",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "763360393",
    socialRason: "CLINICA MEDS LA DEHESA SPA",
    customerType: 1,
    documentNumber: "76.336.039-3",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "",
    email: "patricia.castill@meds.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "La Dehesa Av. Jose Alcalde Delano 10581, Lo Barnechea",
        number: "",
        state: "",
        city: "Santiago",
        neighborhood: "La dehesa",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 37,
    name: "Clinica Las Condes",
    code: "939300007",
    sectorName: "RM",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "939300007",
    socialRason: "CLINICA LAS CONDES S.A.",
    customerType: 1,
    documentNumber: "93.930.000-7",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "+56 9 45644516",
    email: "ymella@clinicalascondes.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Estoril 450, Las Condes, Santiago.",
        number: "",
        state: "",
        city: "Santiago",
        neighborhood: "La Condes",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 38,
    name: "Clinica Bicentenario",
    code: "968859307",
    sectorName: "RM",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "968859307",
    socialRason: "CLINICA BICENTENARIO SpA",
    customerType: 1,
    documentNumber: "96.885.930-7",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "+569 79065495",
    email: "katherine.vergara@redsalud.cl, karla.valenzuela@redsalud.cl, eduardo.mina@redsalud.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "TITAN 3030. ZOCALO - ESTACION CENTRAL",
        number: "",
        state: "",
        city: "Santiago",
        neighborhood: "Estación central",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 39,
    name: "Clinica Avansalud",
    code: "780405201",
    sectorName: "RM",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "780405201",
    socialRason: "CLINICA AVANSALUD SPA",
    customerType: 1,
    documentNumber: "78.040.520-1",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "+569 79065495",
    email: "daniella.acuna@redsalud.cl, maria.mirandam@redsalud.cl, natalia.coppia@redsalud.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "AVDA. SALVADOR 100, PISO -5 Y PISO -4 - PROVIDENCIA, SANTIAGO, RM",
        number: "",
        state: "",
        city: "Santiago",
        neighborhood: "Providencia",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 40,
    name: "Clinica Tabancura",
    code: "780535601",
    sectorName: "RM",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "780535601",
    socialRason: "SERV.MEDICO TABANCURA SPA",
    customerType: 1,
    documentNumber: "78.053.560-1",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "+569 79065495",
    email: "maria.amigo@redsalud.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "AVDA. TABANCURA 1233, TORRE C PISO -2 - VITACURA, RM",
        number: "",
        state: "",
        city: "Santiago",
        neighborhood: "Vitacura",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 41,
    name: "Clinica Bupa",
    code: "762427745",
    sectorName: "RM",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "762427745",
    socialRason: "Clínica Bupa Santiago S.A.",
    customerType: 1,
    documentNumber: "76.242.774-5",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "",
    email: "Yeissy.Becerra@bupa.cl, Pablo.Moya@bupa.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "DEPARTAMENTAL 1455, LA FLORIDA, BODEGA FARMACIA ANDEN -1",
        number: "",
        state: "",
        city: "Santiago",
        neighborhood: "La Florida",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 42,
    name: "CLINICA COLONIAL",
    code: "967900400",
    sectorName: "RM",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "967900400",
    socialRason: "CLINICA COLONIAL S.A.",
    customerType: 1,
    documentNumber: "96.790.040-0",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "56225788581",
    email: "compras@clinicacolonial.cl, clazo@clinicacolonial.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Palacio Riesco 4515, Huechuraba, Santiago, RM",
        number: "",
        state: "",
        city: "Santiago",
        neighborhood: "Huechuraba",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 43,
    name: "SERVICIO MEDICOS LUIS PASTEUR S.A.",
    code: "787301606",
    sectorName: "RM",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "787301606",
    socialRason: "SERVICIO MEDICOS LUIS PASTEUR S.A",
    customerType: 1,
    documentNumber: "78.730.160-6",
    stateRegistration: "",
    isActive: false,
    phone: "",
    mainPhone: "",
    email: "",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "AV. LUIS PASTEUR 5917, VITACURA, RM",
        number: "",
        state: "",
        city: "Santiago",
        neighborhood: "Vitacura",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 44,
    name: "NUCLEO SALUD SPA",
    code: "764254597",
    sectorName: "RM",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "764254597",
    socialRason: "NUCLEO SALUD SPA",
    customerType: 1,
    documentNumber: "76.425.459-7",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "",
    email: "",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Av. Club Hípico 4676, Pedro Aguirre Cerda, Santiago",
        number: "",
        state: "",
        city: "Santiago",
        neighborhood: "Pedro Aguirre Cerda",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 45,
    name: "ACHS - Clínica del Sur",
    code: "760579041",
    sectorName: "S",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "760579041",
    socialRason: "HOSPITAL CLINICO DEL SUR SPA",
    customerType: 1,
    documentNumber: "76.057.904-1",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "569 78502847",
    email: "fsanchez@clinicaaschsud.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Cardenio Avello N° 36, Concepción",
        number: "",
        state: "",
        city: "Concepción",
        neighborhood: "Concepción",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 46,
    name: "ACHS - Clínica los Andes",
    code: "96662020K",
    sectorName: "S",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "96662020K",
    socialRason: "CLINICA LOS ANDES S A",
    customerType: 1,
    documentNumber: "96.662.020-K",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "569 78502847",
    email: "fsanchez@clinicaaschsud.cl, fzuniga@clinicaaschsud.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Genaro Reyes N°581, Los Ángeles, Bio Bio",
        number: "",
        state: "",
        city: "Los Angeles",
        neighborhood: "Los Angeles",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 47,
    name: "CLINICA ANDES SALUD CONCEPCION S.A",
    code: "760189928",
    sectorName: "S",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "760189928",
    socialRason: "CLINICA ANDES SALUD CONCEPCION S.A",
    customerType: 1,
    documentNumber: "76.018.992-8",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "41) 2666000 / Anexo: 7802",
    email: "Fernanda.beltran@andessalud.cl, quiclinico.concepcion@andessalud.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "AV. JORGE ALESSANDRI N°2047 , HUALPEN",
        number: "",
        state: "",
        city: "Concepción",
        neighborhood: "Concepción Hualpen",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 48,
    name: "CLINICA SANATORIO ALEMAN S.A.",
    code: "886116004",
    sectorName: "S",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "886116004",
    socialRason: "CLINICA SANATORIO ALEMAN S.A.",
    customerType: 1,
    documentNumber: "88.611.600-4",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "41-2796172",
    email: "cmartinez@sanatorioaleman.cl, lgonzalezv@sanatorioaleman.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Av. Pedro de Valdivia 801 / Av. Francesa 97, Concepción",
        number: "",
        state: "",
        city: "Concepción",
        neighborhood: "Concepción",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 49,
    name: "CLINICA REGIONAL LIRCAY SPA",
    code: "768426007",
    sectorName: "CS",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "768426007",
    socialRason: "CLINICA REGIONAL LIRCAY SPA",
    customerType: 1,
    documentNumber: "76.842.600-7",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "569 78502847",
    email: "fsanchez@clinicaaschsud.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "2 Poniente N°1.372, Talca, Región del Maule",
        number: "",
        state: "",
        city: "Talca",
        neighborhood: "Talca",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 50,
    name: "CLINICA BIO BIO SPA",
    code: "968859404",
    sectorName: "S",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "968859404",
    socialRason: "CLINICA BIO BIO SPA",
    customerType: 1,
    documentNumber: "96.885.940-4",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "569 83230955",
    email: "jonathan.dominguez@clinicaaschsud.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Av. Jorge Alessandri 3515, Talcahuano",
        number: "",
        state: "",
        city: "Concepción",
        neighborhood: "Talcahuano",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 51,
    name: "CLINICA ANDES SALUD CHILLAN S.A.",
    code: "765150701",
    sectorName: "S",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "765150701",
    socialRason: "CLINICA ANDES SALUD CHILLAN S.A.",
    customerType: 1,
    documentNumber: "76.515.070-1",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "",
    email: "leidy.sirey@andessalud.cl, gerencia.chillan@andessalud.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "PEDRO AGUIRRE CERDA N°35, CHILLAN, REGION DEL NUBLE",
        number: "",
        state: "",
        city: "Chillán",
        neighborhood: "Chillán",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 52,
    name: "CLINICA VALPARAISO S.P.A.",
    code: "995687208",
    sectorName: "CS",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "995687208",
    socialRason: "CLINICA VALPARAISO S.P.A.",
    customerType: 1,
    documentNumber: "99.568.720-8",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "+569 79065495",
    email: "martha.guerra@redsalud.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "AVDA. BRASIL 2350, PISO 1 - VALPARAISO",
        number: "",
        state: "",
        city: "Valparaiso",
        neighborhood: "Valparaiso",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 53,
    name: "CLINICA ALEMANA DE TEMUCO S A",
    code: "966067500",
    sectorName: "S",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "966067500",
    socialRason: "CLINICA ALEMANA DE TEMUCO S A",
    customerType: 1,
    documentNumber: "96.606.750-0",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "56 452201039",
    email: "kcoronado@alemana.cl, eopazo@alemana.cl, logistica.cgt@alemana.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Senador Estébanez 645, Temuco.",
        number: "",
        state: "",
        city: "Temuco",
        neighborhood: "Temuco",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 54,
    name: "CLINICA ANDES SALUD PUERTO MONTT S.A.",
    code: "967668408",
    sectorName: "S",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "967668408",
    socialRason: "Clinica Andes Salud Puerto Montt",
    customerType: 1,
    documentNumber: "96.766.840-8",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "+56 652209184",
    email: "jacquelin.espinoza@andessalud.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Avenida Bellavista N°123, Puerto Montt",
        number: "",
        state: "",
        city: "Puerto Montt",
        neighborhood: "Puerto Montt",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 55,
    name: "CORP DE BENEFICENCIA OSORNO",
    code: "819491003",
    sectorName: "S",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "819491003",
    socialRason: "CORP DE BENEFICENCIA OSORNO",
    customerType: 1,
    documentNumber: "81.949.100-3",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "5664 2454091",
    email: "esteban.garrido@clinicaaschsud.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Zenteno N°1530, Osorno",
        number: "",
        state: "",
        city: "Osorno",
        neighborhood: "Osorno",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 56,
    name: "CLINICA MAGALLANES SPA",
    code: "765429102",
    sectorName: "S",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "765429102",
    socialRason: "CENTRO DE DIAGNOSTICO CLINICA MAGALLANES SPA",
    customerType: 1,
    documentNumber: "76.542.910-2",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "+569 79065495",
    email: "christian.aguilar@redsalud.cl, javiera.martin.ext@redsalud.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Avenida Presidente Manuel Bulnes N° 01448, Punta Arenas.",
        number: "",
        state: "",
        city: "Punta Arenas",
        neighborhood: "Punta Arenas",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 57,
    name: "clinica isamedica",
    code: "966624507",
    sectorName: "CS",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "966624507",
    socialRason: "SOC MEDICA DE ESTABLECIMIENTOS",
    customerType: 1,
    documentNumber: "96.662.450-7",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "",
    email: "afernandez@clinicaisamedica.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Carretera El Cobre Presidente Eduardo Frei Montalva N°884, Rancagua, Región del Libertador Bernardo O'Higgins",
        number: "",
        state: "",
        city: "Rancagua",
        neighborhood: "Rancagua",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 58,
    name: "Clinica Clever Salud",
    code: "782302302",
    sectorName: "CS",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "782302302",
    socialRason: "Clinica Clever Salud",
    customerType: 1,
    documentNumber: "78.230.230-2",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "",
    email: "",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Cáceres N°630, Rancagua, Región del Libertador Bernardo O'Higgins",
        number: "",
        state: "",
        city: "Rancagua",
        neighborhood: "Rancagua",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 59,
    name: "Hospital Clinica de la Fundación de Salud El Teniente",
    code: "709057006",
    sectorName: "CS",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "709057006",
    socialRason: "Fusat",
    customerType: 1,
    documentNumber: "70.905.700-6",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "569 96188107",
    email: "claudia.aguilera@hcf.clinicasdelcobre.cl, yuri.mackerzie@hcf.clinicasdelcobre.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Carretera El Cobre N° 1002, Rancagua",
        number: "",
        state: "",
        city: "Rancagua",
        neighborhood: "Rancagua",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 60,
    name: "Inmobil Inversalud SAP",
    code: "611020252",
    sectorName: "S",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "611020252",
    socialRason: "Inmobil Inversalud SAP",
    customerType: 1,
    documentNumber: "61.102.025-2",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "+569 79065495",
    email: "CHRISTIAN.AGUILAR@REDSALUD.CL",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "MICHIMALONGO S/N LAS CANCHAS - TALCAHUANO",
        number: "",
        state: "",
        city: "Concepción",
        neighborhood: "Concepción",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 61,
    name: "HOSPITAL CLINICO DEL SUR SPA",
    code: "760579041",
    sectorName: "S",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "760579041",
    socialRason: "HOSPITAL CLINICO DEL SUR SPA",
    customerType: 1,
    documentNumber: "76.057.904-1",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "",
    email: "",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Cardenio Avello N° 36, Concepción, Región del Bío Bío",
        number: "",
        state: "",
        city: "Concepción",
        neighborhood: "Concepción",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 62,
    name: "SOCIEDAD CMA-COSTANERA SOCIEDAD ANONIMA",
    code: "760871168",
    sectorName: "S",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "760871168",
    socialRason: "SOCIEDAD CMA-COSTANERA SOCIEDAD ANONIMA",
    customerType: 1,
    documentNumber: "76.087.116-8",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "",
    email: "",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Pedro de Valdivia N°201, Valdivia, Región de Los Ríos",
        number: "",
        state: "",
        city: "Valdivia",
        neighborhood: "Valdivia",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 63,
    name: "clinica huinganal",
    code: "776267783",
    sectorName: "RM",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "776267783",
    socialRason: "OPERACION CLINICA HUINGANAL SPA",
    customerType: 1,
    documentNumber: "77.626.778-3",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "569 83602901",
    email: "loreto.pradines@clinicahuinganal.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "El Rodeo 13278, 7690116 Lo Barnechea",
        number: "",
        state: "",
        city: "Santiago",
        neighborhood: "Lo Barnechea",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  },
  {
    id: 64,
    name: "Clinica Amapolas de Chillan",
    code: "796079002",
    sectorName: "RM",
    districtSectorName: "",
    regionalSectorName: "",
    invoicing: null,
    eightyTwenty: false,
    codeMaster: "796079002",
    socialRason: "Sociedad Clinica Las Amapolas Limitada",
    customerType: 1,
    documentNumber: "79.607.900-2",
    stateRegistration: "",
    isActive: true,
    phone: "",
    mainPhone: "569 74042716",
    email: "ljarpa@clinicaamapolas.cl",
    createdDate: new Date("2026-02-01T13:30:00"),
    updatedDate: new Date("2026-03-09T10:30:00"),
    addresses: [
      {
        zipCode: "",
        street: "Avenida Vicente Mendez 75, Chillán",
        number: "",
        state: "",
        city: "Chillán",
        neighborhood: "Chillán",
        isDeliveryAddress: true
      }
    ],
    contacts: [],
    contracts: [],
    companyId: 10,
    unitId: 3,
    isRemoved: 0,
    procedures: generateProcedures(5),
    profiles: generateProfiles(5),
  }
];

function generateProfiles(baseId: number): any[] {

  let replyCounter = baseId * 100;

  const randomYesNo = (): string =>
    Math.random() > 0.5 ? 'YES' : 'NO';

  const randomUnit = (max = 5000): string =>
    String(Math.floor(Math.random() * max));

  const nextReplyId = (): number => ++replyCounter;

  const reply = (format: string) => ({
    replyId: nextReplyId(),
    value: format === 'YES_NO' ? randomYesNo() : randomUnit()
  });

  return [
    {
      customerId: baseId,
      group: 'TIPOS DE ATENDIMENTO',
      groupProfileId: 1,
      profiles: [
        {
          name: 'HOSPITAL ESCOLA',
          profileId: 1,
          profileReply: reply('YES_NO'),
          format: 'YES_NO'
        },
        {
          name: 'CACON',
          profileId: 1,
          profileReply: reply('YES_NO'),
          format: 'YES_NO'
        },
        {
          name: 'TOTAL DE CIRURGIAS',
          profileId: 1,
          profileReply: reply('UNIT'),
          format: 'UNIT'
        }
      ]
    },
    {
      customerId: baseId,
      group: 'INFORMAÇÕES RELEVANTES',
      groupProfileId: 2,
      profiles: [
        {
          name: 'VAPORIZADOR PRÓPRIO',
          profileId: 2,
          profileReply: reply('YES_NO'),
          format: 'YES_NO'
        },
        {
          name: 'QTD BOMBAS PCA',
          profileId: 1,
          profileReply: reply('UNIT'),
          format: 'UNIT'
        }
      ]
    },
    {
      customerId: baseId,
      group: 'LEITOS',
      groupProfileId: 3,
      profiles: [
        {
          name: 'LEITOS DE UTI',
          profileId: 3,
          profileReply: reply('UNIT'),
          format: 'UNIT'
        },
        {
          name: 'UTI GERAL',
          profileId: 3,
          profileReply: reply('UNIT'),
          format: 'UNIT'
        },
        {
          name: 'UTI PEDIÁTRICA',
          profileId: 3,
          profileReply: reply('UNIT'),
          format: 'UNIT'
        },
        {
          name: 'UTI CORONARIANA',
          profileId: 3,
          profileReply: reply('UNIT'),
          format: 'UNIT'
        }
      ]
    },
    {
      customerId: baseId,
      group: 'ESPECIALIDADES',
      groupProfileId: 4,
      profiles: [
        {
          name: 'ANESTESIOLOGISTAS',
          profileId: 4,
          profileReply: reply('UNIT'),
          format: 'UNIT'
        },
        {
          name: 'INTENSIVISTA',
          profileId: 4,
          profileReply: reply('UNIT'),
          format: 'UNIT'
        },
        {
          name: 'ENFERMEIRO',
          profileId: 4,
          profileReply: reply('UNIT'),
          format: 'UNIT'
        }
      ]
    }
  ];
}

function generateProcedures(baseId: number): ProcedureCategory[] {

  const randomQuantity = (): number =>
    Math.floor(Math.random() * 30) + 5;

  const randomDateThisYear = (): Date => {
    const year = new Date().getFullYear();

    const start = new Date(year, 0, 1).getTime();
    const end = new Date(year, 11, 31).getTime();

    return new Date(start + Math.random() * (end - start));
  };

  return [
    {
      id: baseId,
      category: 'ANESTESIA DE NEUROEIXO',
      items: [
        {
          name: 'RAQUI',
          quantity: randomQuantity(),
          updatedDate: randomDateThisYear(),
          description: 'É uma técnica de anestesia regional, realizada em neuroeixo, que envolve a injeção de um anestésico local e/ou medicação analgésica no espaço epidural.',
          products: [
            {
              code: '70000051',
              brand: 'CLONIDIN',
              product: 'CLONIDIN 150mcg/mL So.Inj 30Est 1Ap.1mL'
            },
            {
              code: '70000062',
              brand: 'DIMORF',
              product: 'DIMORF 0.1mg/mL So.Inj 50Est 1Ap.1mL'
            },
            {
              code: '70000040',
              brand: 'DIMORF',
              product: 'DIMORF 0.2mg/ml So.Inj 50Est 1Ap.1mL'
            }
          ]
        },
        {
          name: 'EPIDURAL',
          quantity: randomQuantity(),
          updatedDate: randomDateThisYear(),
          description: 'É uma técnica de anestesia regional, realizada em neuroeixo, que envolve a injeção de um anestésico local e/ou medicação analgésica no espaço epidural.',
          products: [
            {
              code: '70000051',
              brand: 'CLONIDIN',
              product: 'CLONIDIN 150mcg/mL So.Inj 30Est 1Ap.1mL'
            },
            {
              code: '70000049',
              brand: 'DIMORF',
              product: 'DIMORF 1mg/ml So.Inj 50Est 1Ap.2mL'
            },
            {
              code: '70000055',
              brand: 'FASTFEN',
              product: 'FASTFEN 5mcg/mL So.Inj 30Est 1Ap.2mL'
            }
          ]
        }
      ]
    },
    {
      id: baseId + 1,
      category: 'ANESTESIA BALANCEADA',
      items: [
        {
          name: 'GERAL BALANCEADA',
          quantity: randomQuantity(),
          updatedDate: randomDateThisYear(),
          description: 'É a condição em que a sensibilidade (incluindo a dor) é bloqueada ou temporariamente removida, possibilitando a realização de procedimentos.',
          products: [
            {
              code: '70000761',
              brand: 'DORMIRE',
              product: 'DORMIRE 1mg/mL Sol Inj. - 10amp X 5mL'
            },
            {
              code: '70000036',
              brand: 'DORMIRE',
              product: 'DORMIRE 2mg/mL Sol.Oral. 12fr.10mL'
            },
            {
              code: '70000534',
              brand: 'ETOMIDATO',
              product: 'ETOMIDATO 2mg/mL So.Inj 25Ap.10mL'
            }
          ]
        }
      ]
    }
  ];
}

@Injectable({ providedIn: 'root' })
export class CustomerService {
  private http = inject(HttpClient);

  listCustomers(filters?: { city: string; filter: string; pageNumber: number; pageSize: number; sectors?: string[] | undefined | null }): any {
    let url = `${environment.apiUrl}/customer/list`;
    if (filters) {
      const params = new URLSearchParams();
      if (filters.pageNumber !== undefined) params.append('pageNumber', filters.pageNumber.toString());
      if (filters.pageSize !== undefined) params.append('pageSize', filters.pageSize.toString());
      if (filters.city) params.append('city', filters.city);
      if (filters.filter) params.append('filter', filters.filter);
      if (filters.sectors && filters.sectors.length > 0) {
        filters.sectors.forEach(sector => params.append('sectors', sector));
      }
      url += `?${params.toString()}`;
    }

    let filteredCustomers = CUSTOMERS;
    if (filters?.sectors && filters.sectors.length > 0) {
      filteredCustomers = filteredCustomers.filter(customer => filters.sectors!.includes(customer.sectorName));
    }

    if (filters?.city) {
      const cityTerm = filters.city.toLowerCase();
      filteredCustomers = filteredCustomers.filter(customer =>
        customer.addresses && customer.addresses.some(address => address.city.toLowerCase().includes(cityTerm))
      );
    }

    if (filters?.filter) {
      const filterTerm = filters.filter.toLowerCase();
      filteredCustomers = filteredCustomers.filter(customer =>
        (customer.name && customer.name.toLowerCase().includes(filterTerm)) ||
        (customer.sectorName && customer.sectorName.toLowerCase().includes(filterTerm)) ||
        (customer.code && customer.code.toLowerCase().includes(filterTerm))
      );
    }

    // return this.http.get<CustomerListResponse>(url)
    // Returning mock data for now
    return of({
      "data": filteredCustomers,
      "totalRecords": filteredCustomers.length,
      "pageSize": 10,
      "pageNumber": 1
    })
  }

  getCustomerById(id: number): CustomerByIdModel | undefined {
    return CUSTOMERS.find(x => x.id === id);
  }

  public loadCustomer(): void {
    const value = localStorage.getItem('customers');
    if (value) {
      CUSTOMERS = JSON.parse(atob(value));
    }
  }

  public saveCustomer(customers: CustomerByIdModel[]): void {
    const encoded = btoa(JSON.stringify(customers));

    localStorage.setItem('customers', encoded);
  }


  updateCustomerProfile(customerId: string, profileData: CustomerProfile): any {
    const url = `${environment.apiUrl}/api/profile/${customerId}`;
    return this.http.post<void>(url, profileData);
  }

  getIndicatorsCustomer(): Observable<IndicatorsCustomer> {
    const url = `${environment.apiUrl}/customer/indicators`;
    return this.http.get<IndicatorsCustomer>(url);
  }
}
